var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.084,
    y1: 0.916,
    x2: 0.916,
    y2: 0.084,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d800b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f30072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e50097"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1112",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1112",
    transform: "translate(-380 -413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1133",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1133",
    d: "M55.832,16.456a20.556,20.556,0,0,0-1.3-6.8A13.723,13.723,0,0,0,51.3,4.7a13.727,13.727,0,0,0-4.959-3.23,20.552,20.552,0,0,0-6.8-1.3C36.558.032,35.6,0,28,0S19.442.032,16.456.168a20.559,20.559,0,0,0-6.8,1.3A13.723,13.723,0,0,0,4.7,4.7a13.725,13.725,0,0,0-3.23,4.959,20.555,20.555,0,0,0-1.3,6.8C.032,19.442,0,20.4,0,28s.032,8.559.169,11.545a20.551,20.551,0,0,0,1.3,6.8A13.721,13.721,0,0,0,4.7,51.3a13.719,13.719,0,0,0,4.959,3.23,20.545,20.545,0,0,0,6.8,1.3C19.443,55.968,20.4,56,28,56s8.558-.032,11.544-.168a20.548,20.548,0,0,0,6.8-1.3,14.315,14.315,0,0,0,8.189-8.189,20.55,20.55,0,0,0,1.3-6.8C55.968,36.558,56,35.6,56,28S55.968,19.442,55.832,16.456Zm-5.04,22.859a15.492,15.492,0,0,1-.964,5.2,9.272,9.272,0,0,1-5.314,5.314,15.492,15.492,0,0,1-5.2.964c-2.952.135-3.838.163-11.314.163s-8.362-.028-11.315-.163a15.5,15.5,0,0,1-5.2-.964,8.677,8.677,0,0,1-3.219-2.095,8.674,8.674,0,0,1-2.095-3.219,15.492,15.492,0,0,1-.964-5.2C5.074,36.362,5.045,35.477,5.045,28s.029-8.362.163-11.315a15.5,15.5,0,0,1,.964-5.2,8.681,8.681,0,0,1,2.095-3.22,8.669,8.669,0,0,1,3.22-2.094,15.489,15.489,0,0,1,5.2-.964c2.952-.135,3.838-.163,11.314-.163h0c7.476,0,8.362.029,11.315.164a15.494,15.494,0,0,1,5.2.964,8.682,8.682,0,0,1,3.219,2.094,8.669,8.669,0,0,1,2.094,3.22,15.478,15.478,0,0,1,.964,5.2c.135,2.952.163,3.838.163,11.314S50.926,36.362,50.791,39.315Zm0,0",
    transform: "translate(380 413)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1134",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1134",
    d: "M137.483,124.539a12.945,12.945,0,1,0,12.945,12.945A12.945,12.945,0,0,0,137.483,124.539Zm0,21.347a8.4,8.4,0,1,1,8.4-8.4A8.4,8.4,0,0,1,137.483,145.886Zm0,0",
    transform: "translate(270.56 303.559)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1135",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1135",
    d: "M367,91.161a2.536,2.536,0,1,1-2.536-2.536A2.536,2.536,0,0,1,367,91.161Zm0,0",
    transform: "translate(59.019 334.401)",
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1b83595fc10d98ca2d07038018ee132c.svg";
export { ForwardRef as ReactComponent };